import { fetchCategoryHierarchyByKey } from "@/apis";
import { ICategoryStrategy, NextAction } from "./ICategoryStrategy";
import { Category } from "@/types";
import { hashEncode } from "@/utility";

type BuyCategory = Category & {
    hasChildren: boolean;
    children?: Category[] | null;
};

export class BuyCategoryStrategy implements ICategoryStrategy {
    readonly useUrlDepth = true;
    readonly autoSelectSingleCategory = true;

    async fetchCategories(slug: string): Promise<Category[]> {
        const response = await fetchCategoryHierarchyByKey(slug, {
            sendChildren: true,
            sendAncestors: false,
        });
        const category = response?.data?.response as BuyCategory | undefined;

        if (!category) return [];
        return category.hasChildren ? category.children ?? [] : [category];
    }

    onLeafCategorySelected(category?: Category): NextAction {
        return { kind: 'navigate', to: `/search?cid=${hashEncode(category?.id)}`, replace: true }
    }

    getNextAction(category: Category): NextAction {
        if (!(category as BuyCategory).hasChildren) {
            return this.onLeafCategorySelected(category);
        }

        return { kind: 'navigate', to: `/buy/${category.key}`}
    }
}
